import { __read } from "tslib";
import React, { useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Alert } from 'reactstrap';
import { LoadingIcon } from '../LoadingIcon/LoadingIcon';
import { RoutedEntityPage } from './RoutedEntityPage';
export var EntityItemEditPage = function (_a) {
    var titleProvider = _a.titleProvider, subTitleProvider = _a.subTitleProvider, iconProvider = _a.iconProvider, entityService = _a.entityService, entityStateProvider = _a.entityStateProvider, editor = _a.editor;
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var itemId = useParams().itemId;
    var _b = __read(useState(''), 2), error = _b[0], setError = _b[1];
    var _c = __read(useState(undefined), 2), item = _c[0], setItem = _c[1];
    var Editor = editor;
    if (!itemId) {
        setError('missing itemid url parameter');
    }
    useMemo(function () {
        if (!item) {
            entityService
                .getById(itemId)
                .then(function (response) {
                setItem(response.data);
                setError('');
            })
                .catch(function (err) {
                setError(err.message || err.detail || 'An error occurred while retreiving the item');
            });
        }
    }, [itemId, item]);
    var navModelItem = {
        text: titleProvider({ item: item, pageName: 'edit' }),
        subTitle: subTitleProvider({ item: item, pageName: 'edit' }),
        icon: iconProvider({ item: item, pageName: 'edit' }),
        url: '.'
    };
    var navModel = {
        main: navModelItem,
        node: navModelItem
    };
    return (React.createElement(RoutedEntityPage, { model: navModel },
        error && React.createElement(Alert, { color: "warning" }, error),
        !item && React.createElement(LoadingIcon, null),
        item && (React.createElement(Editor, { item: item, afterSave: function (values, helpers) {
                dispatch(entityStateProvider.loadState());
                navigate("../");
            } }))));
};
//# sourceMappingURL=EntityItemEditPage.js.map